import { createFileRoute, useNavigate } from "@tanstack/react-router";
import TreatmentSectors from "@/components/field/setup/TreatmentSectors";
import useAuth from "@/lib/auth/useAuth";
import { Resource } from "@/types/user";
import { useEffect } from "react";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/treatment-sectors",
)({
    component: TreatmentSectorsPane,
});

function TreatmentSectorsPane() {
    const { isAtLeastDetail } = useAuth();
    const navigate = useNavigate();
    const { fieldId } = Route.useParams();

    useEffect(() => {
        if (!isAtLeastDetail(Resource.TREATMENT_SECTORS)) {
            navigate({
                to: "/dashboard/fields/$fieldId/setup",
                params: { fieldId },
                replace: true,
            });
        }
    }, [isAtLeastDetail, navigate, fieldId]);

    if (!isAtLeastDetail(Resource.TREATMENT_SECTORS)) return null;
    return <TreatmentSectors />;
}
